import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const licenceStatusSlice = createSlice({
  name: "licenceStatus",
  initialState: true,
  reducers: {
    setLicenceValidity: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const privacyPolicyStatusSlice = createSlice({
  name: "privacyPolicyStatus",
  initialState: { status: true },
  reducers: {
    setPrivacyPolicyStatus: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setLicenceValidity } = licenceStatusSlice.actions;
export const { setPrivacyPolicyStatus } = privacyPolicyStatusSlice.actions;

export const licenceStatus = licenceStatusSlice.reducer;
export const privacyPolicyStatus = privacyPolicyStatusSlice.reducer;
